import InternalCheckbox from './checkbox';
import Group from './group';
export { CheckboxSizes, CheckboxTypes } from './group';
var Checkbox = InternalCheckbox;
Checkbox.Group = Group;
export { Group };
export default Checkbox;